<template>
  <BaseCard class="max-w-prose space-y-4 p-6">
    <TextSubtitle>Stel je vraag</TextSubtitle>
    <p>
      Heb je een vraag of wil je iets overleggen? We denken graag met je mee.
    </p>
    <BaseButton @click="router.push({ name: 'messages-contact-general' })">
      Naar het contactformulier
    </BaseButton>
    <template v-if="useUserStore().hasFlag('can-see-contact-form')">
      <BaseDivider />
      <TextSubtitle>Geef een storing door</TextSubtitle>
      <p>
        Wil je een storing of tijdelijke wijziging in het vermogen van een asset
        doorgeven? Vul het storingenformulier in om ons op de hoogte te brengen.
      </p>
      <p>
        Geef wijzigingen minstens {{ PROCESSING_BUSINESS_DAYS }} volledige
        werkdagen (ma - vr) van tevoren door zodat deze tijdig verwerkt kunnen
        worden. Neem bij <span class="font-medium">dringende storingen</span>
        direct telefonisch contact op, zie 'andere contactmogelijkheden'.
      </p>
      <BaseButton @click="router.push({ name: 'messages-contact-disruption' })">
        Naar het storingenformulier
      </BaseButton>
    </template>
  </BaseCard>
  <BaseCard class="max-w-prose space-y-4 p-6">
    <TextSubtitle>Andere contactmogelijkheden</TextSubtitle>
    <ul class="marker:text-primary list-disc pl-4">
      <li>
        We zijn op werkdagen van 08:30 tot 17:00 uur telefonisch bereikbaar op
        <a
          class="decoration-primary hover:text-primary underline decoration-2"
          href="tel:+310850805140"
          aria-label="Bel Repowered op 085 080 5140"
          @click="triggerEvent('contact:click-phone')"
        >
          085 080 5140</a
        >.
      </li>
      <li>
        We zijn per e-mail bereikbaar via
        <a
          class="decoration-primary hover:text-primary underline decoration-2"
          href="mailto:support@repowered.nl"
          aria-label="Mail Repowered op support@repowered.nl"
          @click="triggerEvent('contact:click-email')"
        >
          support@repowered.nl</a
        >.
      </li>
    </ul>
  </BaseCard>
</template>

<script setup>
import { useRouter } from "vue-router"
import { triggerEvent } from "@/services/plausibleService.js"
import { PROCESSING_BUSINESS_DAYS } from "@/stores/repower/contactStore.js"
import useUserStore from "@/stores/userStore.js"
import {
  TextSubtitle,
  BaseCard,
  BaseButton,
  BaseDivider,
} from "@repowerednl/ui-component-library"

const router = useRouter()
</script>
